/**
 * Feature Flags
 *
 * All flags default to `false` (off). Set to `true` locally or per-environment
 * to enable experimental / future features.
 *
 * IMPORTANT: Never ship a flag as `true` unless the corresponding feature is
 * fully tested and approved for that environment.
 */

/**
 * Direct Mailing — Personalized Workflow
 *
 * When `false` (default):
 *   - Clicking "Direct Mailing" lands the user directly on the Add Documents
 *     step with Non-Personalized type auto-selected.
 *   - The Select Mailing Type step is hidden and the Personalized workflow
 *     is unreachable from the UI.
 *
 * When `true`:
 *   - The original Select Mailing Type step is shown as step 1.
 *   - Users can choose between Personalized and Non-Personalized workflows.
 */
export const DIRECT_MAILING_PERSONALIZED_ENABLED = false;
